<template>
  <div class="grid grid-cols-12 gap-x-[30px] p-[15px] md:p-[60px] bg-mtg-dark-cyan bg-opacity-[50%] rounded-[5px] ">
    <div class="col-span-12 md:col-span-6 flex flex-col justify-start xl:justify-center">
      <div class="flex justify-start">
        <div class="inline-flex flex-col items-start justify-center">
          <div class="font-primary font-bold italic text-[14px] text-white pb-[5px]">{{ touch_title_1 }}</div>
          <div class="bg-white w-[80%] h-[1px] mb-[15px]"></div>
        </div>
      </div>
      <div class="font-primary font-extrabold text-[50px] xl:text-[120px] leading-[50px] xl:leading-[120px] text-white uppercase pb-[15px] md:pb-[30px]" v-html="touch_title_2 ">
      </div>
      <div class="font-primary font-bold text-[14px] text-white">{{ touch_title_3 }}</div>
      <div class="font-primary text-[14px] text-white">{{ touch_content_1 }}</div>
      <div class="font-primary text-[14px] text-white pb-[15px]">{{ touch_content_2 }}</div>
    </div>
    <div class="col-span-12 md:col-span-6">
      <ValidationObserver ref="formObserver">
        <form v-on:submit.prevent="onSubmit">
          <div class="grid grid-cols-12 gap-[15px] h-full">
            <div class="col-span-12">
              <ValidationProvider rules="name_required" v-slot="{ errors }">
                <label class="inline-block font-primary text-[13px] text-white pb-[5px]">{{
                    touch_placeholder_1
                  }}</label>
                <input type="text" class="w-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="name" v-bind:placeholder="errors.length ? errors[0] : touch_placeholder_1" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-white border-mtg-medium-cyan'">
              </ValidationProvider>
            </div>
            <div class="col-span-12">
              <ValidationProvider rules="phone_required" v-slot="{ errors }">
                <label class="inline-block font-primary text-[13px] text-white pb-[5px]">{{
                    touch_placeholder_2
                  }}</label>
                <input type="text" class="w-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="phone" v-bind:placeholder="errors.length ? errors[0] : touch_placeholder_2" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-white border-mtg-medium-cyan'">
              </ValidationProvider>
            </div>
            <div class="col-span-12">
              <ValidationProvider rules="email_required|email_valid" v-slot="{ errors }">
                <label class="inline-block font-primary text-[13px] text-white pb-[5px]">{{
                    touch_placeholder_3
                  }}</label>
                <input type="email" class="w-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="email" v-bind:placeholder="errors.length ? errors[0] : touch_placeholder_3" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-white border-mtg-medium-cyan'">
              </ValidationProvider>
            </div>
            <div class="col-span-12">
              <ValidationProvider rules="message_required" v-slot="{ errors }">
                <label class="inline-block font-primary text-[13px] text-white pb-[5px]">{{
                    touch_placeholder_4
                  }}</label>
                <textarea rows="6" class="w-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="message" v-bind:placeholder="errors.length ? errors[0] : touch_placeholder_4" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-white border-mtg-medium-cyan'"></textarea>
              </ValidationProvider>
            </div>
            <div class="col-span-12 flex items-center justify-end">
              <svg v-if="loading" class="animate-spin text-mtg-light-green w-[20px] h-[20px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <button type="submit" class="inline-flex items-center justify-center text-mtg-dark-cyan bg-white border-white py-[10px] px-[30px] border-[1px] rounded-[30px] my-[5px] mx-[10px] cursor-pointer transition-all ease-in-out duration-300 hover:text-white hover:bg-transparent hover:border-white">
                <span class="font-primary font-bold text-[15px]">{{ touch_label }}</span>
              </button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('name_required', {
  ...required,
  message: window.touch_script_data.touch_error_1
});

extend('phone_required', {
  ...required,
  message: window.touch_script_data.touch_error_2
});

extend('email_required', {
  ...required,
  message: window.touch_script_data.touch_error_3
});

extend('email_valid', {
  ...email,
  message: window.touch_script_data.touch_error_4
});

extend('message_required', {
  ...required,
  message: window.touch_script_data.touch_error_5
});

export default {
  name: 'GetInTouchForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      wp_ajax: window.touch_script_data.wp_ajax,
      wp_nonce: window.touch_script_data.wp_nonce,
      wp_action: 'submit_get_in_touch_form',
      recaptcha_token: '',
      loading: false,
      touch_title_1: window.touch_script_data.touch_title_1,
      touch_title_2: window.touch_script_data.touch_title_2,
      touch_title_3: window.touch_script_data.touch_title_3,
      touch_content_1: window.touch_script_data.touch_content_1,
      touch_content_2: window.touch_script_data.touch_content_2,
      touch_placeholder_1: window.touch_script_data.touch_placeholder_1,
      touch_placeholder_2: window.touch_script_data.touch_placeholder_2,
      touch_placeholder_3: window.touch_script_data.touch_placeholder_3,
      touch_placeholder_4: window.touch_script_data.touch_placeholder_4,
      touch_error_1: window.touch_script_data.touch_error_1,
      touch_error_2: window.touch_script_data.touch_error_2,
      touch_error_3: window.touch_script_data.touch_error_3,
      touch_error_4: window.touch_script_data.touch_error_4,
      touch_error_5: window.touch_script_data.touch_error_5,
      touch_label: window.touch_script_data.touch_label,
      touch_submission_succeeded: window.touch_script_data.touch_submission_succeeded,
      touch_submission_failed: window.touch_script_data.touch_submission_failed,
      name: '',
      phone: '',
      email: '',
      message: '',
    };
  },
  methods: {
    async onSubmit () {
      await this.$recaptchaLoaded();
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('wp_nonce', this.wp_nonce);
          formData.append('action', this.wp_action);
          formData.append('name', this.name);
          formData.append('phone', this.phone);
          formData.append('email', this.email);
          formData.append('message', this.message);
          formData.append('recaptcha_token', this.recaptcha_token);
          axios({
            method: 'POST',
            url: this.wp_ajax,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData,
          }).then(() => {
            this.$swal('Sent', this.touch_submission_succeeded, 'success');
            this.name = this.phone = this.email = this.message = '';
            this.$nextTick(() => {
              this.$refs.formObserver.reset();
            });
            this.loading = false;
          }).catch(() => {
            this.$swal('Error', this.touch_submission_failed, 'error');
            this.loading = false;
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
</style>
